import { isExpired } from 'react-jwt'

export const checkIfTokenIsExpired = (jwtToken: string) => {
	return isExpired(jwtToken)
}